export enum EnumTpServicoProduto {
    Invalido = 0,
    Proprio = 1,
    Interno = 2,
    Externo   = 3
}